// src/mixins/responsiveMixin.js

export default {
  data() {
    return {
      isMobile: false,
    };
  },

  mounted() {
    this.isMobile = this.$viewport.isMobile();
    //手机端刷新需要判断是否为isMobile
    const mediaQuery = window.matchMedia('(max-width: 768px)');
    this.isMobile = mediaQuery.matches;
    window.addEventListener('resize', this.checkMobile);
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
};
